import { QRCodeSVG } from 'qrcode.react'
import { ArrowUpRightIcon } from '../components/ArrowUpRightIcon'
import { LINKS, isMobileClient } from '../config/links'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { Seo } from '../seo/Seo'
import { breadcrumbSchema } from '../seo/schema'
import './Download.css'

type Platform = {
  id: string
  label: string
  icon: string
  available: boolean
  href?: string
  badge?: 'beta' | 'soon'
}

const platforms: Platform[] = [
  {
    id: 'android',
    label: 'Android',
    icon: '/downloadicons/android.png',
    available: true,
    href: LINKS.androidPlayStore,
  },
  {
    id: 'ios',
    label: 'iOS & iPadOS',
    icon: '/downloadicons/ios.png',
    available: true,
    href: LINKS.iosAppStore,
  },
  {
    id: 'web',
    label: 'Web',
    icon: '/downloadicons/web.png',
    available: true,
    href: LINKS.webApp,
  },
  {
    id: 'macos',
    label: 'MacOS',
    icon: '/downloadicons/macos.png',
    available: true,
    href: LINKS.iosAppStore,
  },
  {
    id: 'windows',
    label: 'Windows',
    icon: '/downloadicons/windows.png',
    available: false,
  },
  {
    id: 'chrome-extension',
    label: 'Chrome Extension',
    icon: '/downloadicons/chromeos.png',
    available: true,
    href: 'https://chromewebstore.google.com/detail/phlklaacgpochbampgacgefkdmnepaee?utm_source=item-share-cb',
  },
]

export function Download() {
  const showQr = !isMobileClient()

  return (
    <main className="download">
      <Seo
        title="Download Music24 — Jewish Music Radio App"
        description="Download free Jewish music radio for Android, iOS, Mac, Web, and Chrome. Live stations 24/6 — no ads, no subscription."
        path="/download"
        keywords={[
          'download jewish music app',
          'jewish radio app',
          'music24 download',
          'jewish music android',
          'jewish music ios',
        ]}
        jsonLd={breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Download', path: '/download' },
        ])}
      />

      <div className="download__inner shell">
        <Breadcrumbs items={[{ name: 'Home', path: '/' }, { name: 'Download' }]} />

        {/* Hero */}
        <header className="download__hero">
          <h1 className="download__title">Listen anywhere.<br />It's free.</h1>
          <p className="download__sub">Pick your platform and start streaming.</p>
        </header>

        {/* Platform tiles */}
        <div className="download__grid">
          {platforms.map((p, i) => {
            const inner = (
              <>
                <span className="download__tile-icon">
                  <img src={p.icon} alt={p.label} width={52} height={52} />
                </span>
                <span className="download__tile-label">{p.label}</span>
                {p.badge === 'beta' ? (
                  <span className="download__tile-soon download__tile-soon--beta">Beta</span>
                ) : p.available ? (
                  <ArrowUpRightIcon className="download__tile-arrow" />
                ) : (
                  <span className="download__tile-soon">Soon</span>
                )}
              </>
            )

            return p.available && p.href ? (
              <a
                key={p.id}
                href={p.href}
                target="_blank"
                rel="noopener noreferrer"
                className="download__tile download__tile--active"
                style={{ animationDelay: `${120 + i * 60}ms` }}
                aria-label={`Get Music24 for ${p.label}`}
              >
                {inner}
              </a>
            ) : (
              <div
                key={p.id}
                className="download__tile download__tile--dim"
                style={{ animationDelay: `${120 + i * 60}ms` }}
              >
                {inner}
              </div>
            )
          })}
        </div>

        {/* QR — desktop only */}
        {showQr && (
          <div className="download__qr-wrap">
            <div className="download__qr">
              <QRCodeSVG
                value={LINKS.downloadApp}
                size={96}
                bgColor="#ffffff"
                fgColor="#050505"
                level="M"
                marginSize={1}
              />
            </div>
            <p className="download__qr-label">Scan to download</p>
          </div>
        )}
      </div>
    </main>
  )
}
